<template>
    <div id="mainContent">
        <el-container class="container">
            <el-header>
                <top-Nav ref="topNav"></top-Nav>
            </el-header>
            <el-container :class="router ? 'mainContainer' : 'mainContainer1'">
                <Left-Nav :pageState="1"></Left-Nav>
                <el-main>
                    <router-view v-if="isRouterAlive"  @getActive="showMsg" :infoId="infoId" @getItem="showNav"></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import topNav from '../../components/TopNav';
import LeftNav from '../../components/LeftNav';
// import {uploadIp} from  '../../api/ajax'

export default {
    name: 'mainContent',
      provide () {
        return {
        reload: this.reload
        }
    },
    data() {
        return {
             isRouterAlive: true,
            router: sessionStorage.getItem("router") == 'constructionManagement' ? true : false,
            itemActive: '',
            infoId:{
                customerId:'1', //客户id
                buildingId:'2' //建筑id
            },
            isShowLeftNav:'',
                headImgId:"",
            }
    },
    components: {
        LeftNav,
        topNav,
    },
    updated() {
        this.router = sessionStorage.getItem("router") == 'constructionManagement' ? true : false;
    },
    mounted() {
        // 横向滚动条设置
        if (window.innerWidth <= 1366) {
            if (sessionStorage.getItem('router') == 'constructionManagement') {
                document.getElementById('bodyMain').style.overflowX = 'hidden';
            } else {
                document.getElementById('bodyMain').style.overflowX = 'auto';
            }
        }
        window.onresize = () => {
            if (window.innerWidth <= 1366) {
            if (sessionStorage.getItem('router') == 'constructionManagement') {
                document.getElementById('bodyMain').style.overflowX = 'hidden';
            } else {
                document.getElementById('bodyMain').style.overflowX = 'auto';
            }
            }
        }
    },
    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(function(){
                this.isRouterAlive = true
            })
        },
      showNav(val){
            this.isShowLeftNav=val.isShowLeftNav;
        },
      //上传获取图片id 子传父
      // getHeadUrl(val){
      //   this.headImgId=uploadIp+val;
      // },
        showMsg(val){
            this.activeIndex = val;
        },
        leftData(e) {
        },
        handleOpen(key, keyPath) {
        },
        handleClose(key, keyPath) {
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/style.scss";
.mainContainer {
    z-index: 0 !important;
}
.mainContainer1 {
    z-index: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/page/Content/content.vue